<template>
  <v-container style="padding-top: 100px" id="Busqueda">
    <div v-if="show == true" id="cargando" wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
      <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <v-card>
      <v-card-title class="justify-center primary">
        <v-toolbar-title id="titulocard">Búsqueda Avanzada</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon color="white">mdi-magnify</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" lazy-validation ref="formreporte">
          <v-row>
            <v-col cols="12" md="3" sm="12">
              <span style="font-weight: bold">Número del Reporte:</span>
              <v-text-field class="pt-2" v-model="busqueda.nrreporte" outlined width="20px" maxlength="10"
                @change="validarReporte" @keypress="validarRegex($event, 'N')" dense ref="nrreporte"
                @paste="onPaste"></v-text-field>
              <span style="font-weight: bold">Número de Póliza:</span>
              <v-text-field class="pt-2" v-model="busqueda.dapoliza" outlined width="20px" maxlength="50"
                :required="valmin" :error-messages="validacionmin" dense></v-text-field>
              <span style="font-weight: bold">Número Económico:</span>
              <v-text-field class="pt-2" v-model="busqueda.danumeco" outlined width="20px" maxlength="20"
                :required="valminEco" :error-messages="validacionminEco" dense></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <span style="font-weight: bold">Nombre del Asegurado:</span>
              <v-text-field class="pt-2" v-model="busqueda.asnombre" outlined width="20px" maxlength="100"
                :required="valminAseg" :error-messages="validacionminAseg" dense></v-text-field>
              <span style="font-weight: bold">Estado: </span>
              <multiselect style="
                  border-color: brown !important;
                  padding-top: 4px !important;
                " v-model="estados.esclave" deselect-label="No se puede remover el valor seleccionado"
                selected-label="Seleccionado" select-label="Seleccione el estado" track-by="esclave" label="esnombre"
                placeholder="Seleccione una opción" :options="estados.opcionesEstados" :allow-empty="false" dense
                class="multiselectEstados">
              </multiselect>
              <br />
              <span style="font-weight: bold">Número de Serie:</span>
              <v-text-field class="pt-2" v-model="busqueda.daserie" outlined width="20px" maxlength="30"
                :required="valminSerie" :error-messages="validacionminSerie" dense></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <span style="font-weight: bold">Fecha Inicio Reporte:</span>
              <v-dialog ref="dialog" outlined v-model="modal" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="pt-2" v-model="busqueda.fechaInicio" label="" dense v-bind="attrs" v-on="on"
                    outlined readonly>
                  </v-text-field>
                </template>
                <v-date-picker dense v-model="busqueda.fechaInicio" :min="minDateFhIni" :max="date" locale="es"
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="
                    modal = false;
                  busqueda.fechaInicio = null;
                  busqueda.fechaFin = null;
                  ">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(busqueda.fechaInicio)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <span style="font-weight: bold">Fecha Fin Reporte:</span>
              <v-dialog ref="dialog2" outlined v-model="modal2" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="pt-2" v-model="busqueda.fechaFin" label="" outlined dense v-bind="attrs" v-on="on"
                    :required="valfechafin" :disabled="validafechaInicio" :error-messages="validacionfechafin" readonly>
                  </v-text-field>
                </template>
                <v-date-picker v-model="busqueda.fechaFin" :min="busqueda.fechaInicio" :max="date" locale="es" scrollable
                  dense>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="
                    modal2 = false;
                  busqueda.fechaFin = null;
                  ">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog2.save(busqueda.fechaFin)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <span style="font-weight: bold">Fecha Inicio Siniestro:</span>
              <v-dialog ref="dialog3" outlined v-model="modal3" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="pt-2" v-model="busqueda.fechaInicioSin" label="" outlined dense v-bind="attrs"
                    v-on="on" readonly>
                  </v-text-field>
                </template>
                <v-date-picker v-model="busqueda.fechaInicioSin" :min="minDateFhIni" :max="date" locale="es" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="
                    modal3 = false;
                  busqueda.fechaInicioSin = null;
                  busqueda.fechaFinSin = null;
                  ">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog3.save(busqueda.fechaInicioSin)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <span style="font-weight: bold">Fecha Fin Siniestro:</span>
              <v-dialog ref="dialog4" outlined v-model="modal4" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="pt-2" readonly v-model="busqueda.fechaFinSin" label="" outlined dense
                    v-bind="attrs" v-on="on" :disabled="validafechaInicioSin" :required="valfechafinSin"
                    :error-messages="validacionfechafinSin">
                  </v-text-field>
                </template>
                <v-date-picker :disabled="validafechaInicioSin" v-model="busqueda.fechaFinSin"
                  :min="busqueda.fechaInicioSin" :max="date" locale="es" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="
                    modal4 = false;
                  busqueda.fechaFinSin = null;
                  ">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog4.save(busqueda.fechaFinSin)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions style="justify-content: center; align-content: end; padding: 20px">
        <div mt-2>
          <v-btn class="mr-4" color="#536DFE" @click="
            Buscar();
          numpag = 1;
          pagina = 1;
          " style="color: white"
            :disabled="(!valfechafin && !valfechafinSin && !this.valmin && !this.valminAseg && !this.valminEco && !this.valminSerie) == false">Buscar</v-btn>
          <v-btn class="mr-4" @click="limpiar" color="default">Limpiar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2" v-if="verlistado">
      <v-card-title class="pa-5 pb-3 primary">
        <v-icon class="pr-3">mdi-magnify</v-icon>
        <p style="color: white">Reportes</p>
        <v-spacer></v-spacer>
        <div v-if="verificarpermisoexcel">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <JsonExcel :fetch="fetchData" :name="`${nombreArchivo}.xls`" :before-generate="startDownload"
                  :before-finish="finishDownload" worksheet="nombreArchivo">
                  <v-icon dark style="cursor: pointer !important" class="hover">
                    mdi-file-excel-outline
                  </v-icon>
                </JsonExcel>
              </span>
            </template>
            <span>Descargar Excel</span>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="table-responsive">
          <table :id="tableName" class="table table-hover display responsive no-wrap" width="100%">
            <thead>
              <tr>
                <th></th>
                <th v-for="encabezado in headers" :key="encabezado.id">
                  {{ encabezado.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reporte in reportes" :key="reporte.id">
                <td></td>
                <td v-if="reporte.aiclave == 1 || reporte.aiclave == 24 || reporte.aiclave == 23 || reporte.aiclave == 5">
                  <a class="link" @click="BuscarReporte(reporte, $event)">{{
                    reporte.nrreporte
                  }}</a>
                </td>
                <td v-else>{{ reporte.nrreporte }}</td>
                <td>{{ reporte.svnumsin }}</td>
                <td>{{ reporte.ainombre }}</td>
                <td>{{ reporte.esnombre }}</td>
                <td>{{ reporte.asnombre }}</td>
                <td>{{ reporte.svfhreporte }}</td>
                <td>{{ reporte.svfhconclusion }}</td>
                <td>{{ reporte.svfhsiniestro }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <template>
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <div class="ml-2 text-center select-registros">
                  <label>Mostrar </label>
                  <v-select v-model="numreg" :items="regpagina" style="max-width: 60px" class="ml-2 my-custom-select"
                    name="numreg" id="numreg" dense></v-select>
                  <label>registros</label>
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="pt-2 div-paginacion">
                  <v-pagination v-model="pagina" prev-icon="mdi-chevron-double-left" next-icon="mdi-chevron-double-right"
                    :length="numpaginas" :total-visible="5" name="pagina" id="pagina" @input="onPageChange">
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </template>
        </div>
      </v-card-text>
    </v-card>
    <div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"> </v-progress-circular>
      </v-overlay>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import SerBusqueda from "@/services/busqueda/busqueda.service.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import Documentos from "@/services/documentos/documentos.service.js";
import Inicio from "@/services/main/main.service.js";
import JsonExcel from "vue-json-excel";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

export default {
  components: {
    JsonExcel,
  },
  data: function () {
    return {
      expanded: [],
      modal: false,
      modal2: false,
      modal3: false,
      modal4: false,
      minDateFhIni: "",
      minDateFhFin: "",
      pagina: 1,
      reportes: [],
      regpagina: [
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      verlistado: false,
      valid: true,
      estados: {
        opcionesEstados: [],
        esclave: "",
        esnombre: "",
      },
      busqueda: {
        nrreporte: null,
        dapoliza: null,
        danumeco: null,
        daserie: null,
        asnombre: null,
        fechaInicio: null,
        fechaFin: null,
        fechaInicioSin: null,
        fechaFinSin: null,
        estado: null,
      },
      show: false,
      date: new Date().toISOString().substr(0, 10),
      dialog: true,
      dialog2: true,
      dialog3: true,
      dialog4: true,
      numreg: 20,
      numpaginas: 0,
      numpag: 1,
      reportes: [],
      headers: [
        { text: "Reporte Ind", value: "nrreporte", class: "text title" },
        { text: "Número de Siniestro", value: "svnumsin", class: "text title" },
        { text: "Asistencia", value: "ainombre", class: "text title" },
        { text: "Estado", value: "esnombre", class: "text title" },
        { text: "Asegurado", value: "asnombre", class: "text title" },
        { text: "Fecha del Reporte", value: "svfhreporte", class: "text title", },
        { text: "Fecha de Conclusión", value: "svfhconclusion", class: "text title", },
        { text: "Fecha de Siniestro", value: "svfhsiniestro", class: "text title", },
      ],
      validafechaInicio: true,
      validacionfechafin: null,
      valfechafin: false,
      validafechaInicioSin: true,
      validacionfechafinSin: null,
      valfechafinSin: false,
      nombreArchivo: `BusquedaAvanzada_${this.$moment().format("YYYY-MM-DD")}`,
      listado: [],
      local: "es-MX",
      overlay: false,
      prefix: "tabla_",
      randomNum: Math.floor(Math.random() * 1000),
      validacionmin: null,
      valmin: false,
      valminAseg: false,
      validacionminAseg: null,
      valminEco: false,
      validacionminEco: null,
      valminSerie: false,
      validacionminSerie: null,
      nombreArchivo: `BusquedaAvanzada_${this.$moment().format("YYYY-MM-DD")}`,
      verificarpermisoexcel: false,
    };
  },
  watch: {
    async "busqueda.fechaInicio"(val) {
      if (val != null) {
        this.validafechaInicio = false;
        this.busqueda.fechaFin = null;
        this.validacionfechafin = "El campo es requerido";
        this.valfechafin = true;
      } else {
        this.validafechaInicio = true;
        this.validacionfechafin = null;
        this.valfechafin = false;
      }
    },
    async "busqueda.fechaFin"(val) {
      if (val == null && this.busqueda.fechaInicio != null) {
        this.validacionfechafin = "El campo es requerido";
        this.valfechafin = true;
      } else {
        this.validacionfechafin = null;
        this.valfechafin = false;
      }
    },
    async "busqueda.fechaInicioSin"(val) {
      if (val != null) {
        this.validafechaInicioSin = false;
        this.busqueda.fechaFinSin = null;
        this.validacionfechafinSin = "El campo es requerido";
        this.valfechafinSin = true;
      } else {
        this.validafechaInicioSin = true;
        this.validacionfechafinSin = null;
        this.valfechafinSin = false;
      }
    },
    async "busqueda.fechaFinSin"(val) {
      if (val == null && this.busqueda.fechaInicioSin != null) {
        this.validacionfechafinSin = "El campo es requerido";
        this.valfechafinSin = true;
      } else {
        this.validacionfechafinSin = null;
        this.valfechafinSin = false;
      }
    },
    "estados.esclave"(val) {
      this.busqueda.estado = val == null ? null : val.esclave;
    },
    async numreg(nuevoValor) {
      this.verlistado = false;
      this.numreg = nuevoValor;
      this.numpag = 1;
      this.pagina = 1;
      await this.Buscar();
    },
    async "busqueda.dapoliza"(val) {
      if (val != null) {
        this.busqueda.dapoliza = val.trim();
        if (val.length < 4) {
          this.validacionmin = "Debe tener al menos 4 caracteres";
          this.valmin = true;
        } else {
          this.validacionmin = null;
          this.valmin = false;
        }
        if (val.length == 0) {
          this.busqueda.dapoliza = null;
          this.validacionmin = null;
          this.valmin = false;
        }
      }
    },
    async "busqueda.asnombre"(val) {
      if (val != null) {
        this.busqueda.asnombre = val.trim();
        if (val.length < 4) {
          this.validacionminAseg = "Debe tener al menos 4 caracteres";
          this.valminAseg = true;
        } else {
          this.validacionminAseg = null;
          this.valminAseg = false;
        }
        if (val.length == 0) {
          this.busqueda.asnombre = null;
          this.validacionminAseg = null;
          this.valminAseg = false;
        }
      }
    },
    async "busqueda.danumeco"(val) {
      if (val != null) {
        this.busqueda.danumeco = val.trim();
        if (val.length < 4) {
          this.validacionminEco = "Debe tener al menos 4 caracteres";
          this.valminEco = true;
        } else {
          this.validacionminEco = null;
          this.valminEco = false;
        }
        if (val.length == 0) {
          this.busqueda.danumeco = null;
          this.validacionminEco = null;
          this.valminEco = false;
        }
      }
    },
    async "busqueda.daserie"(val) {
      if (val != null) {
        this.busqueda.daserie = val.trim();
        if (val.length < 4) {
          this.validacionminSerie = "Debe tener al menos 4 caracteres";
          this.valminSerie = true;
        } else {
          this.validacionminSerie = null;
          this.valminSerie = false;
        }
        if (val.length == 0) {
          this.busqueda.daserie = null;
          this.validacionminSerie = null;
          this.valminSerie = false;
        }
      }
    },
  },
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    tableName() {
      return this.prefix + this.randomNum;
    },
  },

  methods: {
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData("text");
      if (isNaN(pastedData)) {
        event.preventDefault();
      }
    },
    onPageChange() {
      this.numpag = this.pagina;
      this.Buscar();
    },
    async fetchData() {
      const response = this.listado;
      return response;
    },
    async startDownload() {
      this.overlay = true;
      var datosbusqueda = new FormData();
      datosbusqueda.append("nrreporte", this.busqueda.nrreporte);
      datosbusqueda.append("poliza", this.busqueda.dapoliza);
      datosbusqueda.append("numeco", this.busqueda.danumeco);
      datosbusqueda.append("serie", this.busqueda.daserie);
      datosbusqueda.append("asegurado", this.busqueda.asnombre);
      datosbusqueda.append("fhinicio", this.busqueda.fechaInicio);
      datosbusqueda.append("fhfin", this.busqueda.fechaFin);
      datosbusqueda.append("estado", this.busqueda.estado);
      datosbusqueda.append("fhinicioSin", this.busqueda.fechaInicioSin);
      datosbusqueda.append("fhfinSin", this.busqueda.fechaFinSin);

      await SerBusqueda.BusquedaAvanzadaExcel(this, datosbusqueda).then(
        (resp) => {
          let aux_listado = resp;
          for (let i in aux_listado) {
            for (const [key, value] of Object.entries(aux_listado[i])) {
              if (typeof value === "object") {
                aux_listado[i][key] = "";
              } else {
                aux_listado[i][key] = value.toString();
              }
            }
          }

          this.overlay = false;
          this.listado = aux_listado;
          var formData = new FormData();
          formData.append("lasitio", "Siniestros");
          formData.append("lomodulo", "Busqueda Avanzada");
          formData.append("laaccion", "Descargar Archivo excel");
          formData.append("lacaracteristicas", "Busqueda de reportes");
          formData.append("lanombre", this.nombreArchivo);
          formData.append("ladestinatario", "destinatario");
          Documentos.AlmacenarVisitas(this, formData).then((data) => { });
        }
      );
    },
    finishDownload() {
      this.overlay = false;
    },
    limpiar() {
      this.$refs.formreporte.reset();
      this.estados.esclave = null;
      this.verlistado = false;
      this.validacionmin = null;
      this.valmin = false;
      this.validacionminAseg = null;
      this.valminAseg = false;

      this.validacionminEco = null;
      this.valminEco = false;

      this.validacionminSerie = null;
      this.valminSerie = false;
    },
    validarReporte: function (e) {
      this.aux_nrreporte = e;
      this.nrreporte = this.aux_nrreporte.split("-");
      this.nrreporte = this.nrreporte[0];
    },
    validarRegex(evt, tipo) {
      return MetodosGenerales.validarRegex(evt, tipo);
    },
    async Buscar() {
      if (
        this.busqueda.nrreporte == null &&
        this.busqueda.dapoliza == null &&
        this.busqueda.danumeco == null &&
        this.busqueda.daserie == null &&
        this.busqueda.asnombre == null &&
        this.busqueda.fechaInicio == null &&
        this.busqueda.fechaFin == null &&
        this.busqueda.fechaInicioSin == null &&
        this.busqueda.fechaFinSin == null &&
        this.busqueda.estado == null
      ) {
        this.show = false;
        this.$swal({
          position: "center",
          icon: "info",
          title: "Campos incompletos.",
          text: "Debe de llenar por lo menos un campo",
          showConfirmButton: true,
          allowOutsideClick: false,
          timer: 3500,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      } else {
        this.show = true;
        $("#" + this.tableName + "_paginate").empty();
        $("#" + this.tableName + "_info").remove();
        $("#" + this.tableName + "_filter").remove();
        this.randomNum = Math.floor(Math.random() * 1000);
        this.verlistado = false;
        var datosbusqueda = new FormData();
        datosbusqueda.append("nrreporte", this.busqueda.nrreporte);
        datosbusqueda.append("poliza", this.busqueda.dapoliza);
        datosbusqueda.append("numeco", this.busqueda.danumeco);
        datosbusqueda.append("serie", this.busqueda.daserie);
        datosbusqueda.append("asegurado", this.busqueda.asnombre);
        datosbusqueda.append("fhinicio", this.busqueda.fechaInicio);
        datosbusqueda.append("fhfin", this.busqueda.fechaFin);
        datosbusqueda.append("estado", this.busqueda.estado);
        datosbusqueda.append("fhinicioSin", this.busqueda.fechaInicioSin);
        datosbusqueda.append("fhfinSin", this.busqueda.fechaFinSin);
        datosbusqueda.append("numreg", this.numreg);
        datosbusqueda.append("numpag", this.numpag);

        this.numpaginas = await SerBusqueda.BusquedaAvanzada_Tam(
          this,
          datosbusqueda
        );
        let aux_listado = await SerBusqueda.BusquedaAvanzada(
          this,
          datosbusqueda
        );

        for (let i in aux_listado) {
          for (const [key, value] of Object.entries(aux_listado[i])) {
            if (typeof value === "object") {
              aux_listado[i][key] = "";
            } else {
              aux_listado[i][key] = value.toString();
            }
          }
        }

        this.reportes = aux_listado;
        for (let i in this.reportes) {
          this.reportes[i].nrreporte =
            this.reportes[i].nrreporte + "-" + this.reportes[i].svindice;
        }
        await Inicio.VerificarPermisos(this, "348").then((data) => {
          if (data.length > 0) this.verificarpermisoexcel = true;
        });
        this.verlistado = true;
        this.show = false;

        setTimeout(() => {
          $(`#${this.tableName}`).DataTable({
            paginate: this.paginacion,
            pageLength: this.numreg,
            responsive: {
              details: {
                type: 'column'
              }
            },
            columnDefs: [{
              className: 'dtr-control',
              orderable: false,
              targets: 0
            }],
            order: [4, 'asc'],
            searching: false,
            language: {
              sProcessing: "Procesando...",
              sLengthMenu: "Mostrar _MENU_ registros",
              sZeroRecords: "No se encontraron resultados",
              sEmptyTable: "Sin registros encontrados",
              sInfo: "",
              sInfoEmpty: "",
              sInfoFiltered: "",
              sInfoPostFix: "",
              search: "",
              searchPlaceholder: "Filtrar...",
              sUrl: "",
              sInfoThousands: ",",
              sLoadingRecords: "Cargando...",
              oPaginate: {
                sFirst: "Primero",
                sLast: "Último",
                sNext: "Siguiente",
                sPrevious: "Anterior",
              },
              oAria: {
                sSortAscending:
                  ": Activar para ordenar la columna de manera ascendente",
                sSortDescending:
                  ": Activar para ordenar la columna de manera descendente",
              },
            },
          });
        });
      }
    },
    async BuscarReporte(item, event) {
      if (event.target.classList.contains('link')) {
        let aux = item.nrreporte.split("-");
        let _svindice = aux[1];
        let _nrreporte = aux[0];
        let reporte = {
          nrreporte: _nrreporte,
          svindice: _svindice,
          aiclave: item.aiclave,
          svfhconclusion: item.svfhconclusion,
        };
        let routerName = await MetodosGenerales.obtenerRouterName(parseInt(item.aiclave));
        await MetodosGenerales.guardarEnSesionInfoReporte(reporte, "reporte");
        let url = this.$router.resolve({ name: `${routerName}`, params: { id: 0, } });
        window.open(url.href, '_blank');

      }

    },
  },
  async mounted() {
    SerBusqueda.ObtenerEstados(this);
  },
};
</script>

<style scope>
.hover:hover {
  color: #b9b7b7;
}

.link {
  color: blue;
}

.select-registros {
  display: flex;
  justify-content: left;
  align-items: baseline;
}

.div-paginacion {
  display: flex;
  justify-content: right;
  align-items: center;
}

.my-custom-select .v-select__slot {
  height: 30px;
  font-size: 14px;
}

@media screen and (max-width: 767px) {
  .select-registros {
    display: flex;
    justify-content: center;
    align-items: baseline;
  }

  .div-paginacion {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.multiselectEstados .multiselect__tags {
  min-height: 45px !important;
}
</style>
